/**
 * Masonry — Pinterest-style fluid grid using CSS multi-columns.
 * No JS measurement, perfectly responsive.
 *
 * Children should each be wrapped with a `break-inside-avoid` element so they
 * don't get split across columns.
 *
 * Props:
 *  - cols: { base, sm, lg } column counts (1..4 supported)
 *  - gap: tailwind gap class (default: "gap-4")
 */
const COLS_BASE = { 1: "columns-1", 2: "columns-2", 3: "columns-3", 4: "columns-4" };
const COLS_SM = { 1: "sm:columns-1", 2: "sm:columns-2", 3: "sm:columns-3", 4: "sm:columns-4" };
const COLS_LG = { 1: "lg:columns-1", 2: "lg:columns-2", 3: "lg:columns-3", 4: "lg:columns-4" };

export default function Masonry({
  children,
  cols = { base: 2, sm: 2, lg: 3 },
  gap = "gap-4",
  className = "",
}) {
  const colClass = `${COLS_BASE[cols.base] || "columns-2"} ${COLS_SM[cols.sm] || "sm:columns-2"} ${COLS_LG[cols.lg] || "lg:columns-3"}`;
  return (
    <div className={`${colClass} ${gap} ${className}`}>
      {Array.isArray(children) ? children : [children]}
    </div>
  );
}

/** Direct child wrapper: use this around each item to avoid column splits. */
export function MasonryItem({ children, className = "" }) {
  return (
    <div className={`mb-4 break-inside-avoid ${className}`}>
      {children}
    </div>
  );
}
